import * as React from 'react';
import css from './SiteFooter.module.scss';

const SiteFooter = () => {
  return (
    <div className={css.SiteFooter}>
      <div className={css.SiteFooter__Inner}>
        <div className={css.SiteFooter__Section}>
          <div className={css.SiteFooter__NavBox}>
            <nav className={css.SiteFooter__Nav}>
              <p className={css.SiteFooter__NavTitle}>関連サービス</p>
              <ul className={css.SiteFooter__NavList}>
                <li className={css.SiteFooter__NavListItem}>
                  <a
                    href="https://stores.jp/ec"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={css.SiteFooter__NavListLink}
                  >
                    STORES（ネットショップ）
                  </a>
                </li>
                <li className={css.SiteFooter__NavListItem}>
                  <a
                    href="https://coiney.com?utm_source=re&utm_medium=link&utm_campaign=pa_pcsp_cross_re_top_footer&referer=cross_re_top_footer"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={css.SiteFooter__NavListLink}
                  >
                    STORES 決済（キャッシュレス決済）
                  </a>
                </li>
              </ul>
            </nav>
            <nav className={css.SiteFooter__Nav}>
              <p className={css.SiteFooter__NavTitle}>お役立ちコンテンツ</p>
              <ul className={css.SiteFooter__NavList}>
                <li className={css.SiteFooter__NavListItem}>
                  <a
                    href="https://officialmag.stores.jp"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={css.SiteFooter__NavListLink}
                  >
                    STORES Magazine
                  </a>
                </li>
                <li className={css.SiteFooter__NavListItem}>
                  <a
                    href="https://coiney.com/guide"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={css.SiteFooter__NavListLink}
                  >
                    キャッシュレス決済ナビ
                  </a>
                </li>
                <li className={css.SiteFooter__NavListItem}>
                  <a
                    href="https://blog.coubic.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={css.SiteFooter__NavListLink}
                  >
                    ビズシル
                  </a>
                </li>
              </ul>
            </nav>
            <nav className={css.SiteFooter__Nav}>
              <p className={css.SiteFooter__NavTitle}>導入サポート</p>
              <ul className={css.SiteFooter__NavList}>
                <li className={css.SiteFooter__NavListItem}>
                  <a
                    href="https://webinar.stores.jp"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={css.SiteFooter__NavListLink}
                  >
                    STORES ウェビナー
                  </a>
                </li>
                <li className={css.SiteFooter__NavListItem}>
                  <a
                    href="https://stores.jp/lp/business"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={css.SiteFooter__NavListLink}
                  >
                    STORES ビジネスソリューション
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div className={css.SiteFooter__Section}>
          <div className={css.SiteFooter__BottomNav}>
            <nav className={css.SiteFooter__Nav}>
              <ul className={css.SiteFooter__BottomNavList}>
                <li className={css.SiteFooter__BottomNavListItem}>
                  <a
                    href="https://hey.jp"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={css.SiteFooter__NavListLink}
                  >
                    運営会社
                  </a>
                </li>
                <li className={css.SiteFooter__BottomNavListItem}>
                  <a
                    href="https://hello.hey.jp"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={css.SiteFooter__NavListLink}
                  >
                    採用情報
                  </a>
                </li>
                <li className={css.SiteFooter__BottomNavListItem}>
                  <a
                    href="https://hey.jp/news"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={css.SiteFooter__NavListLink}
                  >
                    お知らせ
                  </a>
                </li>
              </ul>
            </nav>
            <p className={css.SiteFooter__Copyright}>©hey, Inc.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SiteFooter;
